import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState, useRef } from 'react';
import StorefrontUsageTrackerContext from '../context/StorefrontUsageTrackerContext'; // @ts-expect-error untyped import

import StorefrontHeader from '../components/StorefrontHeader';
import StorefrontFooter from '../components/StorefrontFooter'; // @ts-expect-error untyped import

import { track } from '../utils/usageTracker';

const StorefrontWrapper = ({
  children
}) => {
  const [defaultEventProperties, setDefaultEventProperties] = useState({});
  const mobileFilterButtonRef = useRef(null);
  const focusMobileFilterButton = useCallback(() => {
    if (mobileFilterButtonRef) {
      // @ts-expect-error ref exists check
      mobileFilterButtonRef.current.focus();
    }
  }, [mobileFilterButtonRef]);
  const trackInteraction = useCallback((action, extras = {}) => {
    track('storefront-interaction', Object.assign({
      action
    }, defaultEventProperties, {}, extras));
  }, [defaultEventProperties]);
  return /*#__PURE__*/_jsxs(StorefrontUsageTrackerContext.Provider, {
    value: {
      focusMobileFilterButton,
      mobileFilterButtonRef,
      setDefaultEventProperties,
      trackInteraction
    },
    children: [/*#__PURE__*/_jsx(StorefrontHeader, {}), /*#__PURE__*/_jsxs("main", {
      children: [children, /*#__PURE__*/_jsx(StorefrontFooter, {})]
    })]
  });
};

export default StorefrontWrapper;